export default "__VITE_ASSET__8c749ada__"